import { Quote, MapPin } from "lucide-react";

const REVIEWS = [
  {
    name: "Pratima Kadam",
    location: "Wagholi",
    text:
      "From my first trimester to delivery, every scan at Nidan was handled with warmth and precision. The reports were clear and shared with my gynaecologist on time.",
  },
  {
    name: "Vikas Pudke",
    location: "Kesnand",
    text:
      "Got a digital X-Ray and Doppler on the same visit. Zero waiting, very professional staff and the radiologist explained every finding patiently.",
  },
  {
    name: "Pravin Sakpal",
    location: "Wagholi",
    text:
      "I had a very good experience at Nidan for my dental OPG X-ray. Quick, smooth and very comfortable. Polite staff guided me throughout, and I received clear, high-quality reports on time.",
  },
  {
    name: "Pratibha Adsul",
    location: "Bakori",
    text:
      "The 4D scan experience was beautiful. They took extra time to show us our baby and answered every small question without rushing.",
  },
];

function initials(name) {
  return name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 lg:py-28 bg-[#f8fafc]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0099CC]">
            Stories of Care
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Trusted by Families &amp; Doctors{" "}
            <span className="text-[#0099CC]">Across Wagholi &amp; Pune</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              data-testid={`testimonial-${i}`}
              className="relative bg-white rounded-2xl p-7 sm:p-8 border border-slate-100 shadow-[0_4px_20px_rgba(15,23,42,0.03)] hover:shadow-[0_18px_40px_rgba(15,23,42,0.07)] transition-shadow"
            >
              <Quote className="absolute top-6 right-6 w-9 h-9 text-[#00BFFF]/15" />
              <p className="text-base sm:text-lg text-slate-700 leading-relaxed">“{r.text}”</p>
              <div className="mt-6 flex items-center gap-4 pt-5 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#00BFFF] to-[#0099CC] text-white font-semibold flex items-center justify-center">
                  {initials(r.name)}
                </div>
                <div>
                  <p className="font-semibold text-slate-900">{r.name}</p>
                  <p className="text-sm text-slate-500 inline-flex items-center gap-1">
                    <MapPin className="w-3.5 h-3.5" /> {r.location}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
